<template>
  <div :class="classContainer" id="app">
    <!-- LOADING -->
    <div v-if="appLoading">
      <div class="loading"></div>
    </div>
    <!-- FIM LOADING -->

    <!-- MENSAGENS DE ERRO -->
    <div v-if="serverError" class="alert-dismissable nb-top-message fade show" role="alert">
      <button type="button" class="close" data-dismiss="alert" @click="handleCloseError()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span>{{ message }}</span>
    </div>
    <!-- FIM MENSAGENS DE ERRO -->

    <div v-if="appLogin">
      <router-view></router-view>
    </div>

    <div v-if="appLogged && !appLogin && $route.name !== 'contador_empresas'" :tabindex="1">
      <div v-if="appNFe || appERP" class="d-md-none nb-renova">
        <span>Para uma melhor utilização do sistema e vinculação do certificado
          digital para o envio de Nota Fiscal utilizar o sistema em
          computadores.</span>
      </div>
      <div v-if="(appTrial || appFree) && appERP" class="nb-trial">
        <span>Você está utilizando uma conta gratuita!</span>
        <v-button class="ml-3" label="Assinar Agora!" :success="true" @click="handleRenovar"></v-button>
      </div>
      <div v-if="appTrial && !appERP" class="nb-trial">
        <span>Seu período de testes expira em
          {{ appDataExpiracao | formatData }}</span>
        <v-button class="ml-3" label="Assinar Agora!" :success="true" @click="handleRenovar"></v-button>
      </div>
      <div v-if="appAvisoRenovacao" class="nb-renova">
        <span>
          <strong>Sua assinatura vence em
            {{ appDataExpiracao | formatData }}! </strong>Clique no botão ao lado caso ainda não tenha renovado.</span>
        <v-button class="ml-3" label="Renovar" :success="true" @click="handleRenovar"></v-button>
      </div>
      <div v-if="showAmbienteHomologacao" class="nb-homolog">
        <div class="mt-1">
          <span>Atenção! Sistema em ambiente de homologação.</span>
        </div>
      </div>

      <bar-top @action="getAction" @logout="handleLogout"></bar-top>

      <div class="container" v-if="showAlertCert">
        <alert-cert :certificados="certificado" />
      </div>


      <!-- ======== EM PRODUCAO ========= -->
      <!-- <bar-top-nfe v-if="menuNFe" @action="getAction" @logout="handleLogout"></bar-top-nfe> -->
      <!-- <bar-top-fv v-if="menuForcaVendas" @action="getAction" @logout="handleLogout"></bar-top-fv> -->
    </div>

    <!-- <div class="botao-novo-pedido">
        <a href="/296379/pedidos/atalho/novo/">
            <span class="fa fa-tag" style="margin-bottom: 0"></span>
        </a>
    </div> -->

    <div v-if="showApp && !appLogin" id="main" class="container" style="padding-top: 20px">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>

      <div class="jumbotron jumbotron-fluid">
        <p class="text-center" style="color: silver">Nota Brasil 2026</p>
      </div>

      <md-message v-if="appShowMessage" :title="appTitleMessage" :message="appMessage" :kind="appKindMessage"
        @close="handleCloseMessage">
      </md-message>

      <!-- PERGUNTAS -->
      <md-message v-if="false" :title="titleMessage" :message="message" :kind="kindMessage" @close="handleCloseError()">
      </md-message>
      <!-- FIM PERGUNTAS -->

      <!-- LIMITE DE PLANO ALCANÇADO -->
      <md-limite-plano v-if="showLimitePlano"></md-limite-plano>

      <!-- <app-guia v-if="!appForcaVendas"></app-guia> -->
    </div>

    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import BarTop from "./components/bar-top";
import AppGuia from "./forms/app-guia";
import { SysVars } from "./main";
import { apiORDS, apiORDSapp } from "./shared/api-functions";
import mdLimitePlano from "./components/md-limite-plano.vue";
import AlertCert from './components/alert-cert.vue'

export default {
  name: "app",

  components: {
    BarTop,
    AppGuia,
    mdLimitePlano,
    AlertCert
  },

  data() {
    return {
      action: "",
      titleMessage: "",
      message: "",
      kindMessage: "error",
      auth: {},
      showApp: false,
      auth: null,
      login: false
    };
  },

  computed: {
    showAlertCert() {
      if (this.$route.name != 'home' &&
        this.$route.name != 'guianfe' &&
        this.$route.name != 'painelvarejo' &&
        this.$route.name != 'guiapedidos')
        return false;

      if (!this.appForcaVendas && this.certificado)
        return true
      else
        return false
    },
    certificado() {
      return [...this.$store.getters.getSessao.certificado];
    },
    appShowMessage() {
      return SysVars.appShowMessage;
    },

    appTitleMessage() {
      return SysVars.appTitleMessage;
    },

    appKindMessage() {
      return SysVars.kindMessage;
    },

    appMessage() {
      return SysVars.appMessage;
    },

    appLoading() {
      return SysVars.appLoading;
    },

    serverError() {
      return SysVars.serverError;
    },

    toastWarning() {
      return SysVars.toastWarning;
    },

    toastSuccess() {
      return SysVars.toastSuccess;
    },

    toastError() {
      return SysVars.toastError;
    },

    appLogged() {
      return SysVars.appLogged;
    },

    appForcaVendas() {
      return SysVars.appForcaVendas;
    },

    appVarejo() {
      return SysVars.appVarejo;
    },

    appNFe() {
      return SysVars.appNFe;
    },

    appERP() {
      return SysVars.appERP;
    },

    appEndTrial() {
      return SysVars.appEndTrial;
    },

    appBlocked() {
      return SysVars.appBlocked;
    },

    appAvisoRenovacao() {
      return SysVars.appAvisoRenovacao;
    },

    appTrial() {
      return SysVars.appTrial;
    },

    appFree() {
      return SysVars.appFree;
    },

    showAmbienteHomologacao() {
      return (
        (this.appNFe || this.appERP) &&
        SysVars.ambienteHomologacaoNFe &&
        (this.$route.name == "nflist" || this.$route.name == "nfsaida")
      );
    },

    showLimitePlano() {
      return SysVars.showLimitePlano;
    },

    appDataExpiracao() {
      return SysVars.appDataExpiracao;
    },

    metadata() {
      return this.$store.getters.getEntities;
    },

    perfilUsuarioPadrao: function () {
      return this.$store.getters.getSessao.perfil == "3";
    },

    appLogin: function () {
      if (this.$route.name == "login" || this.login) return true;
      else return false;
    },

    classContainer: function () {
      if (SysVars.appForcaVendas) {
        return "";
      } else {
        // return "container-min-width"
        return "";
      }
    }
  },

  methods: {
    crmCounters() {
      return;

      if (!this.appLogged) return;

      apiORDS(this.$store.getters.urlOrds + "crm/email/count", null, true).then(
        result => {
          if (result.items.length > 0)
            SysVars.countEmail = result.items[0].email;
          else SysVars.countEmail = null;
        }
      );

      apiORDS(
        this.$store.getters.urlOrds + "crm/agenda/count",
        null,
        true
      ).then(result => {
        if (result.items.length > 0)
          SysVars.countAgenda = result.items[0].agenda;
        else SysVars.countAgenda = null;
      });

      let vm = this;
      setTimeout(function () {
        vm.crmCounters();
      }, 60000);
    },

    getAction(action) {
      //executa a acao dos botoes do menu
      this.action = action;
      if (action == "register") {
        this.showRegisterForm();
      }
    },

    handleCloseMessage() {
      SysVars.appShowMessage = false;
      SysVars.appTitleMessage = null;
      SysVars.appMessage = null;
    },

    handleCloseError() {
      //fecha tela de erro ao clicar em OK
      SysVars.appError = false;
      SysVars.serverError = false;
    },

    handleLogout() {
      //efetua o logout, zerando os dados de autenticacao e direciona para a pagina de login
      this.$store.dispatch("logout");
      SysVars.appLogged = false;
      SysVars.primeiroAcesso = true;
      this.login = true;
      this.$router.push({ path: "/login", query: this.$route.query });
    },

    handleRenovar() {
      this.$router.push("/minhaconta");
    },

    closeForm() {
      this.action = "";
    },

    showRegisterForm() {
      this.showRegister = true;
    },

    async loadEnvironment() {
      // ENTRA AQUI PELO WATCH DAS VARIAVEIS SYSVARS.APPBLOCKED, SYSVARS.APPENDTRIAL, SYSVARS.APPLOGGED
      setTimeout(function () {
        if (Tawk_API) {
          if (typeof Tawk_API.showWidget === "function") {
            Tawk_API.showWidget();
          }
        }
      }, 1000);

      if (this.loadingEnvironment) return;

      this.loadingEnvironment = true;

      if (this.auth) {
        await this.$store.dispatch("loadEnv", this.auth);
      } else {
        this.auth = JSON.parse(window.sessionStorage.getItem("authObj"));
      }
      await this.$store.dispatch("loadSessao", this);
      await this.$store.dispatch("loadMetadata");

      await apiORDSapp(this, "sessao/meuplano/", "get", null).then(result => {
        if (result) SysVars.plano = result;
        else SysVars.plano = { plano_atual: {}, historico: [] };
      });

      SysVars.usuarioComum = this.$store.getters.getSessao.perfil > 1;
      SysVars.usuarioForcaVendas = this.$store.getters.getSessao.perfil == 3; //neste caso exibe o menu força de vendas
      SysVars.usuarioVarejoPDV = this.$store.getters.getSessao.perfil == 5; //neste caso exibe o menu força de vendas
      SysVars.usuarioAdministrador =
        this.$store.getters.getSessao.perfil == 0 ||
        this.$store.getters.getSessao.perfil == 1;
      SysVars.hasRepresentation =
        this.$store.getters.getSessao.possui_usu_representante == "S";
      SysVars.loja_b2b = this.$store.getters.getSessao.loja_b2b == "S";
      SysVars.guia = this.$store.getters.getSessao.showguia == "S";
      SysVars.usaIntegracao = this.$store.getters.getSessao.integracao == "S";

      SysVars.appTrial = this.auth.login.istrial;
      SysVars.appDataExpiracao = this.auth.login.dataexpiracao;
      SysVars.appAvisoRenovacao = this.auth.login.avisorenovacao;
      // SysVars.appPlanoContratado = this.auth.login.planocontratado
      if (this.auth.login.apps.length) {
        SysVars.appVarejo = this.auth.login.apps.indexOf("VAREJO") >= 0;
        SysVars.appLoja = this.auth.login.apps.indexOf("LOJA") >= 0;
        SysVars.appForcaVendas =
          this.auth.login.apps.indexOf("FV") >= 0 ||
          this.auth.login.apps.indexOf("LOJA") >= 0;
        SysVars.appNFe = this.auth.login.apps.indexOf("NFE") >= 0;
        SysVars.appERP = this.auth.login.apps.toString().includes("ERP");
      }
      SysVars.appFree = this.auth.login.isfree;

      if (this.auth.login.isblocked) SysVars.appBlocked = true;
      else if (this.auth.login.isendtrial) SysVars.appEndTrial = true;

      SysVars.forceUrl = null;
      SysVars.urlBlocked = null;

      if (SysVars.appNFe || SysVars.appERP) {
        SysVars.appLogged = true;
        this.login = false;
        if (SysVars.appEndTrial || SysVars.appBlocked) {

          if (SysVars.plano && SysVars.plano.plano_atual && (SysVars.plano.plano_atual.controle_app == 'ERP2' || SysVars.plano.plano_atual.controle_app == 'ERP3' || SysVars.plano.plano_atual.controle_app == 'ERP4')) {
            SysVars.forceUrl = '/minhaconta'
            SysVars.urlBlocked = '/minhaconta'
            this.$router.push('/planos/erp')
          } else {
            SysVars.forceUrl = '/minhaconta'
            SysVars.urlBlocked = '/minhaconta'
            this.$router.push('/minhaconta')
          }
        } else {
          if (
            this.$route.path == "/login" ||
            this.$route.path == "/registronfe" ||
            this.$route.path == "/registroloja"
          ) {
            //AO DAR F5 NA PAGINA, DEVE CONTINUAR NA MESMA
            const urlParams = new URLSearchParams(window.location.search);
            const redirectTo = urlParams.get('redirect_to') || this.$route.query.redirect_to;
            if (redirectTo) {
              this.$router.push(redirectTo);
            } else {
              this.$router.push("/");
            }
          }
        }
      }

      if (!SysVars.appNFe && !SysVars.appERP) {
        if (SysVars.appEndTrial || SysVars.appBlocked) {
          SysVars.urlBlocked = "/assinar";
          SysVars.forceUrl = "/assinar";
          this.$router.push("/assinar");
        } else {
          this.login = false;
          SysVars.appLogged = true;
          if (SysVars.appLoja && SysVars.guia) this.$router.push("/guialoja");
          else {
            if (this.$route.path == "/login") {
              //AO DAR F5 NA PAGINA, DEVE CONTINUAR NA MESMA
              const urlParams = new URLSearchParams(window.location.search);
              const redirectTo = urlParams.get('redirect_to') || this.$route.query.redirect_to;
              if (redirectTo) {
                this.$router.push(redirectTo);
              } else {
                this.$router.push("/");
              }
            }
          }
        }
      }

      //exibe a aplicação quando terminar de carregar o ambiente e o METADATA
      if (this.metadata) {
        this.showApp = true;
      } else {
        this.showApp = false;
      }
      //

      if (window.location.search.includes("redirect_to")) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("redirect_to");
        window.history.replaceState(
          {},
          "",
          cleanUrl.pathname + cleanUrl.search + cleanUrl.hash
        );
      }

      this.loadingEnvironment = false;

      this.auth = null;

      this.$scrollTo(0);

      this.crmCounters();

      Tawk_API.visitor = {
        name: this.$store.getters.getSessao.nome,
        email: this.$store.getters.getSessao.email
      };
      Tawk_API.onLoad = function () {
        Tawk_API.setAttributes(
          {
            name: this.$store.getters.getSessao.nome,
            email: this.$store.getters.getSessao.email
          },
          function (error) { }
        );
      };
    }
  },

  watch: {
    metadata: function (value) { },

    $route() {
      this.$nextTick(() => {
        jQuery(".tooltip").remove();
      });
    },

    serverError: function (value) {
      if (SysVars.serverErrorStatus == 0) {
        this.message = "Erro: " + SysVars.serverErrorText;
      } else {
        this.message =
          "Erro na requisição ao servidor: (" +
          SysVars.serverErrorStatus +
          ") " +
          SysVars.serverErrorText;
      }
    },

    //watch para controle de notificações
    toastWarning: function (value) {
      if (this.toastWarning != "") {
        this.$snotify.warning(this.toastWarning);
        SysVars.toastWarning = "";
      }
    },

    toastSuccess: function (value) {
      if (this.toastSuccess != "") {
        this.$snotify.success(this.toastSuccess);
        SysVars.toastSuccess = "";
      }
    },

    toastError: function (value) {
      if (this.toastError != "") {
        this.$snotify.error(this.toastError);
        SysVars.toastError = "";
      }
    },

    appLogged: function (value) {
      //exibe a pagina principal ao efetuar login
      if (value) {
        if (
          this.$route.path == "/registronfe" ||
          this.$route.path == "/registroloja" ||
          this.$route.path == "/contador/empresas"
        ) {
          this.loadEnvironment();
        } else if (this.$route.path != "/login") {
          this.$router.push({
            path: this.$route.path,
            query: this.$route.query
          });
        } else {
          this.loadEnvironment();
        }
      } else {
        this.$router.push({ path: "/login", query: this.$route.query });
      }
    },

    appEndTrial: function (value) {
      if (value) {
        this.loadEnvironment();
      }
    },

    appBlocked: function (value) {
      if (value) {
        this.loadEnvironment();
      }
    }
  },

  created() {
    this.showApp = false;

    SysVars.appForcaVendas = true;

    if (this.$route.name == "registro") {
      this.showApp = true;
      this.$router.push({ path: "/registro", query: this.$route.query });
      return;
    }
    if (this.$route.name == "registropedidos") {
      this.showApp = true;
      this.$router.push("/registropedidos");
      return;
    }
    if (this.$route.name == "registronfe") {
      this.showApp = true;
      this.$router.push({ path: "/registronfe", query: this.$route.query });
      return;
    }
    if (this.$route.name == "registroloja") {
      this.showApp = true;
      this.$router.push("/registroloja");
      return;
    }
    if (this.$route.name == "recuperar") {
      this.showApp = true;
      this.$router.push("/recuperar");
      return;
    }

    if (this.$route.name == "ativar") {
      this.showApp = true;
      this.$router.push({ path: "ativar", query: this.$route.query });
      return;
    }

    if (this.$route.name == "senha") {
      this.showApp = true;
      this.$router.push({ path: "senha", query: this.$route.query });
      return;
    }

    if (this.$route.name == "imprimir-pedido") {
      this.showApp = true;
      this.$router.push({ path: "imprimir-pedido", query: this.$route.query });
      return;
    }

    if (this.$route.name == "login") {
      this.$router.push({ path: "/login", query: this.$route.query });
      return;
    }

    //verifica se já está autenticado ao carregar a pagina (em case de F5)
    const urlParams = new URLSearchParams(window.location.search);
    const queryObj = {};
    urlParams.forEach((value, key) => {
      queryObj[key] = value;
    });

    const hasAutologin = urlParams.has('token_autologin');
    if (hasAutologin) {
      window.sessionStorage.removeItem("authObj");
      this.auth = null;
    } else {
      this.auth = JSON.parse(window.sessionStorage.getItem("authObj"));
    }

    if (!this.auth || !this.auth.auth) {
      this.login = true;
      this.$router.push({ path: "/login", query: queryObj });
    } else {
      this.loadEnvironment();
    }
  },

  mounted() {
    // app.js

    window.addEventListener("desativar-guia", async () => {
      await this.$apiGuiaUsuarioDesativar();
      this.$erpToastSuccess("Guia desativado com sucesso.");


    });

    jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
      icons: {
        time: "fa fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fa fa-calendar-check",
        clear: "fa fa-trash",
        close: "fa fa-times-circle"
      }
    });
  }
};
</script>

<style>
.height-80 {
  height: 80vh;
}

.height-90 {
  height: 90vh;
}

.height-70 {
  height: 70vh;
}

.height-60 {
  height: 60vh;
}

.def-title {
  color: #2b6292;
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
}

.def-title2 {
  color: #07a7cf;
  text-transform: uppercase;
  font-size: 14px;
  /* color: #adb62f;  */
}

.btn {
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  line-height: 2;
  /* border-radius: 0.70rem; */
  font-size: 13px;
}

.btn-outline-secondary {
  color: #174b79;
  background-color: transparent;
  background-image: none;
  border-color: #5f5f5f3b;
}

.btn-video {
  color: #174b79;
  background-color: #ffc107;
  background-image: none;
  border-color: #ffc107;
}

.btn.nb-btn-video {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.12);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn.nb-btn-video .fa-youtube-play {
  color: #ef4444;
  font-size: 20px;
  line-height: 1;
  transition: transform 0.2s ease, color 0.2s ease;
}

.btn.nb-btn-video:hover {
  background: #ef4444;
  border-color: #dc2626;
  color: #fff;
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.35);
  transform: translateY(-2px) scale(1.05);
}

.btn.nb-btn-video:hover .fa-youtube-play {
  color: #fff;
  transform: scale(1.1);
}

.btn.nb-btn-video:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.25);
}

.btn-green {
  color: #fff;
  background-color: green;
  background-image: none;
  border-color: green;
}

.btn-blue {
  color: #fff;
  background-color: #174b79;
  background-image: none;
  border-color: #174b79;
}

.btn-red {
  color: #fff;
  background-color: red;
  background-image: none;
  border-color: red;
}

.btn-orange {
  color: #fff;
  background-color: orange;
  background-image: none;
  border-color: orange;
}

.nb-btdef {
  color: #ffffff;
  background-color: #174b79;
  border-color: #aeafb1;
}

.nb-btdef:hover,
.nb-btdef:focus,
.nb-btdef:active,
.nb-btdef.active,
.open .dropdown-toggle.nb-btdef {
  color: #ffffff;
  background-color: #c59f2f;
  border-color: #dbb233;
}

.nb-btdef:active,
.nb-btdef.active,
.open .dropdown-toggle.nb-btdef {
  background-image: none;
}

.nb-btdef.disabled,
.nb-btdef[disabled],
fieldset[disabled] .nb-btdef,
.nb-btdef.disabled:hover,
.nb-btdef[disabled]:hover,
fieldset[disabled] .nb-btdef:hover,
.nb-btdef.disabled:focus,
.nb-btdef[disabled]:focus,
fieldset[disabled] .nb-btdef:focus,
.nb-btdef.disabled:active,
.nb-btdef[disabled]:active,
fieldset[disabled] .nb-btdef:active,
.nb-btdef.disabled.active,
.nb-btdef[disabled].active,
fieldset[disabled] .nb-btdef.active {
  background-color: #dfba49;
  border-color: #dbb233;
}

.nb-btdef .badge {
  color: #dfba49;
  background-color: #ffffff;
}

/*
  .confirm-btn {
    color: #ffffff;
    background-color: #454647;
    border-color: #404040;
  }

  .confirm-btn:hover,
  .confirm-btn:focus,
  .confirm-btn:active,
  .confirm-btn.active,
  .open .dropdown-toggle.confirm-btn {
    color: #ffffff;
    background-color: #21779E;
    border-color: #404040;
  }

  .confirm-btn:active,
  .confirm-btn.active,
  .open .dropdown-toggle.confirm-btn {
    background-image: none;
  }

  .confirm-btn.disabled,
  .confirm-btn[disabled],
  fieldset[disabled] .confirm-btn,
  .confirm-btn.disabled:hover,
  .confirm-btn[disabled]:hover,
  fieldset[disabled] .confirm-btn:hover,
  .confirm-btn.disabled:focus,
  .confirm-btn[disabled]:focus,
  fieldset[disabled] .confirm-btn:focus,
  .confirm-btn.disabled:active,
  .confirm-btn[disabled]:active,
  fieldset[disabled] .confirm-btn:active,
  .confirm-btn.disabled.active,
  .confirm-btn[disabled].active,
  fieldset[disabled] .confirm-btn.active {
    background-color: #454647;
    border-color: #404040;
  }

  .confirm-btn .badge {
    color: #454647;
    background-color: #ffffff;
  }
  */

.lbl {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  color: rgb(99, 98, 98);
  font-size: 13px;
  text-overflow: ellipsis;
  /* overflow: hidden;  PROBLEMA DE ALINHAMENTO */
  white-space: nowrap;
}

.lbl2 {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-weight: 700;
  color: gray;
}

.lbl-title-produto {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 16px;
  font-weight: 700;
  color: #4993d2;
}

.lbl-list-produto {
  display: inline-block;
  max-width: 100%;
  /* margin-bottom: 5px;
    margin-right: 5px; */
  /* font-size: 16px; */
  font-weight: 700;
  color: #4993d2;
}

.lbl-title-orcamento {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 12px;
  font-weight: 700;
  color: #b8b50b;
}

.lbl-total-documento {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 24px;
  font-weight: 800;
  color: #636363;
}

.lbl-edit {
  display: inline-block;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  white-space: nowrap;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 13px;
  color: #808080bb;
  font-weight: 500;
}

.lbl-edit-sm {
  display: inline-block;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 12px;
  color: rgba(128, 128, 128, 0.733);
}

.lbl-link {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-weight: 700;
  font-size: 16px;
  color: #4eafc7;
  cursor: pointer;
}

.lbl-title {
  display: inline-block;
  max-width: 100%;
  font-size: 20px;
  /* border-bottom: 2px solid #ffc60a;     */
  text-transform: uppercase;
  color: #565656;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0 0 -1px;
}

.lbl-list {
  /* display: inline-block; */
  margin-bottom: 5px;
  max-width: 100%;
  margin-right: 5px;
  font-size: 13px;
  color: #808080bb;
  white-space: nowrap;
  /* overflow: hidden;  PROBLEMA DE ALINHAMENTO */
  text-overflow: ellipsis;
}

.lbl-list-detalhe {
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  margin-left: 0;
  margin-right: 10px;
  color: #424242;
  white-space: nowrap;
}

.data-list {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  color: #383838;
  font-size: 14px;
  /* white-space: nowrap; */
}

.data-list-sm {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  color: #383838;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list-icon {
  font-size: 24px;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border: solid 1px #e0e0e0;
  box-sizing: border-box;
  height: 38px;
  width: 42px;
  flex-shrink: 0;
}

.lbl-tot {
  width: 100%;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  color: gray;
  font-size: 14px;
}

.lbl-center {
  text-align: center;
}

.lbl-yellow {
  color: yellow;
}

.lbl-green {
  color: green;
}

.lbl-blue {
  color: blue;
}

.lbl-orange {
  color: goldenrod;
}

.lbl-gray {
  color: gray;
}

.lbl-red {
  color: red;
}

.decrase-lbl-title {
  font-size: 13px;
}

.decrase-lbl {
  font-size: 10px;
}

.error {
  color: red;
}

.border-yellow {
  border-color: yellow;
}

.border-green {
  border-color: green;
}

.border-black {
  border-color: black;
}

.border-gray {
  border-color: gray;
}

.border-red {
  border-color: red;
}

.border-blue {
  border-color: blue;
}

.border-orange {
  border-color: goldenrod;
}

.badge {
  display: inline-block;
  padding: 0.5em 0.5em;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1.3rem;
}

.badge-green {
  color: #fff;
  background-color: #80b852;
}

.badge-green-color {
  color: #627d4c;
}

.badge-red {
  color: #fff;
  background-color: #a72828e1;
}

.badge-red-o {
  color: #a72828e1;
  border: 2px solid #a72828e1;
}

.badge-orange {
  color: #fff;
  background-color: goldenrod;
}

.badge-yellow {
  color: gray;
  background-color: #ffe871;
}

.badge-blue {
  color: #fff;
  background-color: #006dfc8a;
}

.badge-gray {
  color: #fff;
  background-color: gray;
}

.badge-silver {
  color: #fff;
  background-color: silver;
}

.badge-yellow-outline {
  color: #07a7cf;
  border: 2px solid #07a7cf;
}

.badge-dash-mes {
  color: #07a7cf;
  border: 1px solid #07a7cf;
  font-size: 12px;
  margin-top: 5px;
}

.badge-green-outline {
  color: #80b852;
  border: 2px solid #80b852;
}

.badge-incluir {
  display: inline-block;
  padding: 0.2em 0.3em;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.7rem;
}

/* LISTAS */

.mark-gray {
  position: absolute;
  width: 3px;
  height: 100%;
  float: left;
  background-color: gray;
  z-index: 2;
}

.mark-green {
  position: absolute;
  width: 3px;
  height: 100%;
  float: left;
  background-color: LawnGreen;
  z-index: 2;
}

.mark-red {
  position: absolute;
  width: 3px;
  height: 100%;
  float: left;
  background-color: red;
  z-index: 2;
}

.mark-yellow {
  position: absolute;
  width: 3px;
  height: 100%;
  float: left;
  background-color: yellow;
  z-index: 2;
}

.mark-orange {
  position: absolute;
  width: 3px;
  height: 100%;
  float: left;
  background-color: orange;
  z-index: 2;
}

.mainbox {
  overflow: hidden;
  /* display: flex; */
  position: relative;
  width: 100%;
  margin: 5px 0 5px;
  border-bottom: 1px solid #eee;
}

.mainbox-select {
  /* overflow: hidden;  */
  display: flex;
  position: relative;
  width: 100%;
  margin: 5px 0 5px;
  border-bottom: 1px solid #eee;
}

.nb-modal-scrollable-container .mainbox {
  /* CORREÇÃO DO CALENDARIO DATETIME-PICKER NA TELA DE REGRAS DE IMPOSTO */
  overflow: visible !important;
  border-bottom: none;
}

.box {
  position: relative;
  width: 100%;
  float: right;
  padding: 5px;
  background-color: white;
}

/* MODAL */

.nb-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  display: table;
  transition: opacity 0.3s ease;
}

.nb-modal-varejo {
  position: fixed;
  z-index: 9998;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  /* background-color: #f0f4f9; */
  background-color: #ffffffff;
  display: inherit;
  transition: opacity 0.3s ease;
  padding: 0;
}

.nb-modal {
  /* padding: 10px; */
  max-width: 95%;
  max-height: 95%;
  position: absolute;
  top: 2%;
  left: 50%;
  z-index: 2;
  opacity: 1;
  border-style: solid;
  border-width: 6px;
  border-color: black;
  background: #ffffff;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -webkit-transition-delay: 0.5s;
  -ms-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.nb-modal-90 {
  min-width: 95%;
  min-height: 95%;
}

.nb-modal-70 {
  min-width: 70%;
  min-height: 70%;
}

.nb-modal-80 {
  min-width: 80%;
  min-height: 80%;
}

.nb-modal-50 {
  min-width: 50%;
  max-height: 50%;
}

.nb-modal-60 {
  min-width: 60%;
  min-height: 60%;
}

.nb-modal-body {
  /* position: relative; */
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
  display: block;
  position: absolute;
  width: 100%;
  height: 75%;
  overflow: auto;
  padding-bottom: 80px;
}

.nb-modal-footer {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #f1f4f9;
  border-top: 1px solid #c9d3dd;
  padding: 20px 0;
  max-height: 80px;
}

.nb-modal-header {
  display: flex;
  -webkit-box-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 10px 0 10px;
  border-bottom: 1px solid #e9ecef;
  /* border-top-left-radius: 0.3rem; */
  /* border-top-right-radius: 0.3rem; */
}

.nb-modal-scrollable {
  position: fixed;
  z-index: 9998;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(15, 43, 73, 0.25);
  display: inherit;
  transition: opacity 0.3s ease;
}

.nb-modal-scrollable-container {
  position: absolute;
  top: 2%;
  left: 50%;
  z-index: 2;
  opacity: 1;
  border-style: solid;
  border-width: 6px;
  border-color: black;
  background: #ffffff;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-transition-delay: 0.5s;
  -ms-transition-delay: 0.5s;
  transition-delay: 0.5s;
  /* overflow: auto; */
}

.nb-modal-full-height {
  position: relative;
  padding: 10px;
  left: 50%;
  z-index: 2;
  max-height: 100%;
  max-width: 100%;
  z-index: 1;
  box-shadow: 0 0 2px 0 #0000003d, 0 8px 10px 1px #0000000d,
    0 3px 14px 2px #0000000f, 0 5px 5px -3px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-transition-delay: 0.5s;
  -ms-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.nb-modal-scrollable-body {
  padding-top: 15px;
}

.nb-modal-scrollable-footer {
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  border-top: 1px solid #c9d3dd;
  padding: 20px 0;
  max-height: 80px;
}

/* FIM-MODAL */

/* LOADING SPINNER */

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 9999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(247, 233, 233, 0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.jumbotron {
  background-color: transparent !important;
}

.nb-top-message {
  text-align: center;
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 10000;
  max-width: 100%;
  font-size: 14px;
  font-weight: 500;
  padding: 20px;
  background: #ffd600;
}

.nb-trial {
  text-align: center;
  position: relative;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  background: #fffa70;
  color: gray;
}

.nb-renova {
  text-align: center;
  position: relative;
  width: 100%;
  font-size: 14px;
  /* font-weight: 600; */
  padding: 10px;
  color: #0052a5;
  border-color: #b7cdfd #b7cdfd #b7cdfd #2687e9;
  background: #dbe6fe;
}

.nb-homolog {
  text-align: center;
  position: relative;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  padding: 10px;
  background: #f86161;
  color: rgb(255, 255, 255);
  z-index: 10;
}

/* .theme-message {
    text-align: center;
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 10000;
    max-width: 100%;
    border-left-style: none;
    border-right-style: none;
    border-top-style: none;
    display: block;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
    text-indent: 45px;
    margin: 0 ! important;
    padding-top: 14px;
    padding-bottom: 14px;
    background-image: none ! important;
}

.theme-message-error {
    border-color: #E34F4D ! important;
    color: #BC1132 ! important;
    border-top: 1px solid #F9B3C1;
    border-bottom: 1px solid #F9B3C1;
    border-left: 3px solid #F43E61;
    border-right: 1px solid #F9B3C1;
    background: #FCD9E0 no-repeat 11px 10px ! important;}
  */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
  {
  opacity: 0;
}

.nb-margin-bottom {
  margin-bottom: 20px !important;
}

.nb-margin-top {
  margin-top: 20px !important;
}

.nb-margin-topbottom {
  margin-bottom: 20px !important;
  margin-top: 20px !important;
}

.nb-margin-right {
  margin-right: 5px;
}

.nb-fixed-footer-toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #f1f4f9;
  border-top: 1px solid #c9d3dd;
  padding: 20px 0;
  max-height: 80px;
  z-index: 203;
}

.nb-shortcut {
  border: 1px solid transparent;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  border-radius: 0.7rem;
  color: #174b79;
  border-color: #5f5f5f3b;
}

.nb-shortcut-danger {
  border: 1px solid transparent;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  border-radius: 0.7rem;
  color: #bc1132;
  border-color: #f9b3c1;
  background-color: F9B3C1;
}

.nb-shortcut-img {
  font-size: 1rem;
}

/* TABS PAGECONTROL */

.nav-tabs {
  background-color: #fff;
}

.nav-tabs .nav-link {
  /* border: 1px solid transparent; */
  /* border-top-left-radius: 0.25rem; */
  /* border-top-right-radius: 0.25rem; */
  /* border-color: #e9ecef #e9ecef #dee2e6; */
  /* background-color: #f8f8f9; */
  align-items: center;
  justify-content: center;
  /* min-height: 50px; */
  min-width: 100px;
  color: gray;
  font-size: 14px;
  border-radius: 0px;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #fff;
  border: none;
  border-bottom: 3px solid #1161bc;
  font-weight: 600;
  color: #2b6292;
  font-size: 14px;
  /* text-transform: uppercase */
}

/* .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus { */
.nav-tabs .nav-link:hover {
  background-color: rgb(238, 238, 238);
}

.nav-tabs-mobile .nav-link-mobile {
  /* border: 1px solid transparent; */
  /* border-top-left-radius: 0.25rem; */
  /* border-top-right-radius: 0.25rem; */
  /* border-color: #e9ecef #e9ecef #dee2e6; */
  /* background-color: #f8f8f9; */
  align-items: center;
  justify-content: center;
  /* min-height: 50px; */
  min-width: 100px;
  color: gray;
  font-size: 14px;
  border-radius: 0px;
}

.nav-tabs-mobile .nav-link-mobile.active,
.nav-tabs-mobile .nav-item.show .nav-link-mobile {
  background-color: #fff;
  border: none;
  border-bottom: 3px solid #1161bc;
  font-weight: 600;
  color: #2b6292;
  font-size: 14px;
  /* text-transform: uppercase */
}

/* .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus { */
.nav-tabs-mobile .nav-link-mobile:hover {
  background-color: rgb(238, 238, 238);
}

/* FIM TABS PAGECONTROL */

.nb-dash-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  height: 100%;
  position: relative;
  margin: 0;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.nb-dash-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px -1px rgba(0, 0, 0, 0.08);
}

.nb-dash-detalhes {
  display: flex;
  align-items: center !important;
  height: 40px;
  border-top: 1px solid #f1f5f9;
  background: #f8fafc;
  padding: 0 14px;
}

/* SPINNER */
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border 0.75s linear infinite;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  height: 1rem;
  border-width: 0.2em;
}

/* FIM SPINNER */

/* .form-control:focus {
    border-color: #7eef68cc;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset, 0px 0px 8px rgba(126, 239, 104, 0.6);
}

.select2-container:focus {
    border-color: #7eef68cc;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset, 0px 0px 8px rgba(126, 239, 104, 0.6);
} */

.botao-novo-pedido {
  top: 75px;
  left: 36px;
  position: fixed;
  z-index: 30;
}

.botao-novo-pedido a,
.botao-novo-pedido a:hover {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.5), 0 2px 10px rgba(0, 0, 0, 0.2);
  color: #00cc62;
  cursor: pointer;
  display: flex;
  position: relative;
  height: 52px;
  width: 52px;
  justify-content: center;
  align-items: center;
}

.default-container {
  background: #ffffff;
  border: 1px solid #c9d3dd;
  padding: 15px;
  box-shadow: 0 0 10px 0 rgba(201, 211, 221, 0.4);
}

.select2-container--open {
  z-index: 999999 !important;
  width: 100% !important;
}

.typeahead {
  z-index: 1051;
  margin-top: 2px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  color: gray;
}

.typeahead li {
  border-bottom: 1px solid #efefef;
  padding: 10px;
}

.typeahead li:hover {
  color: white;
  background-color: #267da5;
  cursor: pointer;
}

.typeahead .active {
  color: white;
  background-color: #267da5;
}

.typeahead * {
  white-space: normal !important;
}

.typeahead-data {
  white-space: normal !important;
}

.typeahead-title {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 18px;
}

.typeahead-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  *border-right-width: 2px;
  *border-bottom-width: 2px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  -moz-background-clip: padding;
  background-clip: padding-box;
}

.counter {
  /* background-color: #fca300bf; */
  background-color: #fc0000bf;
  color: #fff;
  font-size: 10px;
  border-radius: 50%;
  line-height: 16px;
  width: 16px;
  height: 16px;
  text-align: center;
  display: inline-block;
  /* top: 3px; */
  position: absolute;
}

/* .header__counter {
  position: absolute;
  top: -8px;
  right: -8px;
} */

.no-scroll {
  overflow: hidden;
}

body {
  -webkit-font-smoothing: antialiased;
  font-style: normal;
  font-size: 14px;
  margin: 0;
  font-family: "Open Sans", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  /* line-height: 20px; */
  color: #333;
  background-color: #f5f5f5;
}

/* ALERT */

.nb-alert {
  border-radius: 0 3px 3px 0;
  border: 1px solid;
  border-left: 3px solid;
  padding: 20px;
  position: relative;
  /* font-size: 85%; */
}

.nb-alert.info {
  color: #0052a5;
  border-color: #b7cdfd #b7cdfd #b7cdfd #2687e9;
  background: #dbe6fe;
}

.nb-alert.warning {
  color: #b98e00;
  border-color: #ffdf79 #ffdf79 #ffdf79 #ffc200;
  background: #fff4ce;
}

.nb-alert.error {
  color: rgb(255, 0, 0) a2 !important;
  border-top: 1px solid #ff0000a2;
  border-bottom: 1px solid #ff0000a2;
  border-left: 3px solid #fd0a3b;
  border-right: 1px solid #ff0000a2;
  background: #ff000011 url(/versions/current/assets/images/icones/icon-error.png) no-repeat 11px 10px !important;
}

.nb-alert.nb-alert-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/* FIM ALERT */

/* TIMELINE */

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline>li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline>li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}

/* FIM TIMELINE */

/* CRM */

.email-address {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  color: #808080bb;
  font-size: 14px;
}

.pipeline .etapa {
  box-sizing: border-box;
  background-image: none;
  float: left;
  color: #7a7a7f;
  margin: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  height: auto;
}

.pipeline .header {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 60px;
  position: relative;
  color: #7a7a7f;
  width: 100%;
  padding: 5px 5px 5px 10px;
  background-color: #ebebeb;
  clip-path: polygon(calc(100% - 6px) 0px,
      100% 50%,
      calc(100% - 6px) 100%,
      2px 100%,
      8px 50%,
      2px 0px);
}

.pipeline-6col .etapa {
  width: 16.66%;
}

.pipeline-5col .etapa {
  width: 20%;
}

.pipeline-4col .etapa {
  width: 25%;
}

.pipeline-3col .etapa {
  width: 33.33%;
}

.pipeline-10col .etapa {
  width: 10%;
}

.pipeline strong {
  font-size: 20px;
  font-weight: 700;
}

.pipeline .list-group {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 5px;
  margin-bottom: 20px;
  min-height: 500px;
  /* min-height: 100%; */
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  height: 100%;
}

.pipeline .list-group:hover {
  background-color: #ebebeb;
}

.card-perdido {
  background-color: rgb(243, 241, 241);
}

.card-negocio {
  position: relative;
  max-width: 100%;
  border: 1px solid #c9d3dd;
  background-color: white;
  padding: 10px;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 6px;
}

.card-negocio .title:hover {
  cursor: pointer;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: 00000087;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: #020202bb;
  text-overflow: ellipsis;
}

.card-text {
  display: inline-block;
  max-width: 100%;
  margin-right: 5px;
  font-size: 13px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #969696;
}

.card-value {
  font-size: 13px;
  display: inline-block;
  max-width: 100%;
  margin-right: 5px;
  color: #969696;
  overflow: hidden;
}

.title-etapa {
  font-weight: 700;
  font-size: 16px;
  color: #00000087;
}

.icon {
  display: inline-block;
  width: 25px;
  font-size: 18px;
  text-align: center;
}

.icon-outros {
  color: #dedede;
}

.icon-email {
  color: #04da44;
}

.icon-atrasado {
  color: red;
}

.icon-sem-agenda {
  /* color: #b1b1b1;   */
  color: #ffe871;
  cursor: pointer;
}

.icon-agenda {
  color: #627d4c;
  cursor: pointer;
}

.card-negocio .estagnado {
  font-size: 12px;
  padding: 0 5px 0 5px;
  margin-right: 5px;
  position: relative;
  /* background: #c4004b; */
  background: #ffe871;
  /* color: white; */
}

.card-negocio .tag {
  position: absolute;
  /* border-radius: 3px; */
  font-size: 12px;
  padding: 0 5px 0 5px;
  right: -15px;
  width: 15px;
  height: 20px;
  /* color: white; */
}

.tag.atrasado {
  background: red;
}

.perdido {
  font-size: 12px;
  padding: 0 5px 0 5px;
  margin-right: 5px;
  position: relative;
  background: #c4004b;
  color: white;
}

.ganho {
  border-radius: 4px;
  margin-left: 3px;
  padding: 3px;
  background: rgb(12, 133, 42);
  color: white;
  font-size: 10px;
}

.lbl-negocio {
  font-size: 28px;
  font-weight: 600;
  color: black;
}

.lbl-deal-subtitle {
  font-weight: 600;
  color: black;
}

.lbl-deal-title {
  font-size: 120%;
  font-weight: 600;
  color: black;
}

.lbl-no-deal {
  font-size: 22px;
  font-weight: 600;
  color: black;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.no-deals {
  position: absolute;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  margin: auto;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 0px;
}

.section {
  border-bottom: 1px solid #dee2e6;
  color: #757575 !important;
  font-size: 18px;
  text-transform: uppercase;
}

.atrasado {
  color: red;
}

.default-container .card {
  /* border: 1px solid #00000007;     */
  background-color: #dbdbdb07;
}

.container .container-full-width {
  position: absolute;
  margin-left: 0;
  margin-right: 0;
  max-width: 100%;
  width: 100%;
  left: 0;
}

@media only screen and (max-width: 768px) {
  .container {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}

.icon-negocio {
  display: inline-block;
  margin-right: 10px;
  line-height: 28px;
  width: 48px;
  height: 48px;
  text-align: center;
  border: 1px solid #bdbdbd;
  border-radius: 50px;
  color: #3e2f68;
  /* text-shadow: 0px 1px 0px rgba(0,0,0,0.5); */
  box-shadow: 0px 0px 1px 1px #e0e0e0;
  background-color: #fff;
}

.deal-icon {
  font-size: 24px;
  color: #808080bb;
}

.tag-input-color {
  border-radius: 2px;
  margin-left: 3px;
  padding: 2px 2px 2px;
  color: white;
  text-transform: uppercase;
  font-size: 11px;
}

.tag-input-color:hover {
  cursor: pointer;
  box-shadow: 0 3px 3px 0 #979797;
}

.title-form {
  display: inline-block;
  max-width: 100%;
  font-size: 20px;
  /* border-bottom: 2px solid #ffc60a;     */
  text-transform: uppercase;
  color: #020202;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0 0 -1px;
}

.no-content {
  min-height: 60px;
  padding-top: 30px;
  font-size: 18px;
  font-weight: 500;
  text-align: center !important;
  width: 100% !important;
}

.deal-list {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 5px;
  border-bottom: 1px solid #eee;
  min-height: 35px;
  cursor: pointer;
}

.deal-list:hover {
  background-color: #fafafa;
}

.deal-form-side {
  position: fixed;
  top: 0px;
  right: 0px;
  width: 900px;
  max-width: 100%;
  height: 100%;
  z-index: 1;
  box-shadow: 0 0 2px 0 #0000003d, 0 8px 10px 1px #0000000d,
    0 3px 14px 2px #0000000f, 0 5px 5px -3px rgba(0, 0, 0, 0.1);
}

.deal-form {
  background-color: rgb(255, 255, 255);
  display: flex;
  position: relative;
  height: 100%;
}

.deal-form-1 {
  width: 100%;
  box-sizing: border-box;
  display: block;
  z-index: 3;
  position: relative;
  right: 0px;
  top: 0px;
  bottom: 0px;
  box-shadow: rgba(38, 41, 44, 0.12) 0px 0px 5px;
  transform: translate3d(0px, 0px, 0px);
  flex-flow: column;
  background: rgb(255, 255, 255);
  transition: transform 0.4s cubic-bezier(0.08, 0.47, 0.27, 0.98) 0s;
  overflow: hidden;
  transition: height 0.25s ease-in;
}

.deal-form-2 {
  opacity: 1;
  height: 100%;
  width: 100%;
  transition: opacity 0.2s cubic-bezier(0.08, 0.47, 0.27, 0.98) 0.2s;
}

.deal-form-3 {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  position: relative;
  z-index: 3;
  height: 100%;
  overflow-x: auto;
}

.deal-form-left {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  padding: 0px 16px 16px;
  padding-top: 12px;
  border-right: 1px solid rgb(238, 238, 238);
}

.deal-form-right {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 16px 16px;
}

.sticky {
  padding: 10px 0 10px 0px;
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  /* position: sticky; */
  top: 0px;
  z-index: 1;
}

.guia-video {
  position: fixed;
  z-index: 9998;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(15, 43, 73, 0.25);
  display: flex;
  transition: opacity 0.3s ease;
  align-items: center;
  justify-content: center;
}

.guia-video-content {
  position: absolute;
  left: 50%;
  z-index: 2;
  opacity: 1;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-transition-delay: 0.5s;
  -ms-transition-delay: 0.5s;
  transition-delay: 0.5s;
  width: 650px;
  background-color: #fff;
  padding-bottom: 30px;
  border-radius: 10px
}

.guia-icon {
  /* color: silver; */
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.obrigatorio {
  /* color: #f30202; */
  /* border: 1px solid #f30202;
  border-radius: 0.25rem; */
  box-shadow: 0px 2px 0px #f30202
}

.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #000;
  cursor: pointer;
}

.color-container {
  display: -ms-flexbox;
  /* display: flex; */
  -ms-flex-align: center;
  align-items: center;
  padding: 0.1rem 0.3rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.vd-text-grand {
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  font-size: 27.5px;
  line-height: 1.16667;
  color: #3a4953;
}

.vd-text-hero {
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  font-size: 24px;
  line-height: 1.5;
}

.vd-text-medium {
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  line-height: 1.16667;
  color: #3a4953;
}

.vd-text-grand,
.vd-text-hero,
.vd-text-medium {
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  word-break: break-word;
  margin: 0;
}

.container-min-width {
  /* min-width: 800px; */
}

/* MODAL */
body:has(.modal-dialog) {
  overflow: hidden;
}

.modal-dialog.modal-full-w {
  max-width: 100%;
  overflow-y: initial !important;
  margin: 5px;
}

.modal-content.modal-full-h {
  max-width: 100%;
  margin: 5px;
  height: 98vh !important;
  max-height: 100%;
  overflow-y: auto
}
</style>



// WEBPACK FOOTER //
// src/App.vue